import QuickCategory from './QuickCategory';

export default QuickCategory;
